import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import FreeOfChargeCategoryForm from './FreeOfChargeCategoryForm';
import { FREE_OF_CHARGE_CATEGORY_PATH } from '../../../../config/paths';
import {
  clearFreeOfChargeCategory,
  getFreeOfChargeCategory,
  putFreeOfChargeCategory,
} from '../../../../actions/sales/FreeOfChargeCategory';

const EditFreeOfChargeCategory = ({
  breadcrumbs,
  dispatchGetFreeOfChargeCategory,
  dispatchClearFreeOfChargeCategory,
  dispatchPutFreeOfChargeCategory,
  match: {
    params: { id: freeOfChargeCategoryId },
  },
  loading,
  freeOfChargeCategory,
}) => {
  useLayoutEffect(() => {
    dispatchGetFreeOfChargeCategory({ freeOfChargeCategoryId });

    return () => dispatchClearFreeOfChargeCategory();
  }, []);

  const onSubmit = (values) => {
    const existing = (values.freeOfChargeSubCategoryList || [])
      .filter((s) => s && s.id != null)
      .map((s) => ({
        id: s.id,
        name: s.name,
        active: !!s.active,
        freeOfChargeSubCategoryUserList: (s.authorizers || []).map((a) => ({
          customerId: a.value,
          active: true,
        })),
      }));

    const created = (values.newFreeOfChargeSubCategoryList || [])
      .filter((s) => s && s.name && s.name.trim())
      .map((s) => ({
        name: s.name,
        active: true,
        freeOfChargeSubCategoryUserList: (
          s.freeOfChargeSubCategoryUserList || []
        ).map((a) => ({
          customerId: a.value,
          active: true,
        })),
      }));

    const payload = {
      name: values.name,
      description: values.description,
      active: !!values.active,
      freeOfChargeSubCategoryList: [...existing, ...created],
    };

    dispatchPutFreeOfChargeCategory(freeOfChargeCategoryId, payload);
  };

  const getAuthorizerLabel = (authWrapper = {}) => {
    const cust = authWrapper.customer || {};
    return (
      cust.fullName ||
      [cust.firstName, cust.lastName].filter(Boolean).join(' ') ||
      authWrapper.name ||
      `Autorizador ${
        authWrapper.id || authWrapper.freeOfChargeAuthorizerId || authWrapper.id
      }`
    );
  };

  const generateInitialValues = (freeOfChargeJson = {}) => ({
    name: freeOfChargeJson.name,
    description: freeOfChargeJson.description,
    active: Boolean(freeOfChargeJson.active),
    freeOfChargeSubCategoryList: (
      freeOfChargeJson.freeOfChargeSubCategoryList || []
    ).map((sc = {}) => ({
      name: sc.name,
      active: Boolean(sc.active),
      id: sc.id,

      authorizers: (sc.freeOfChargeSubCategoryUserList || []).map((a) => ({
        value: a.customerId,
        label: getAuthorizerLabel(a),
      })),
    })),
  });

  let content;

  if (loading) content = <Loader />;
  else if (freeOfChargeCategory.isEmpty())
    content = <NoDataResource returnPage={FREE_OF_CHARGE_CATEGORY_PATH} />;
  else
    content = (
      <FreeOfChargeCategoryForm
        edit
        onSubmit={onSubmit}
        initialValues={generateInitialValues(freeOfChargeCategory.toJS())}
      />
    );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Editar Categoría Código de Descuento"
      subtitle="Editar categoría código de descuento"
      content={content}
    />
  );
};

EditFreeOfChargeCategory.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearFreeOfChargeCategory: PropTypes.func.isRequired,
  dispatchGetFreeOfChargeCategory: PropTypes.func.isRequired,
  dispatchPutFreeOfChargeCategory: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  freeOfChargeCategory: PropTypes.instanceOf(Immutable.Map).isRequired,
};

EditFreeOfChargeCategory.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearFreeOfChargeCategory: clearFreeOfChargeCategory,
  dispatchGetFreeOfChargeCategory: getFreeOfChargeCategory,
  dispatchPutFreeOfChargeCategory: putFreeOfChargeCategory,
};

const mapStateToProps = (
  { SalesUnit },
  {
    match: {
      params: { id },
    },
  },
) => ({
  breadcrumbs: [
    ...SalesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Categoría Para Servicios a Título Gratuito',
      href: FREE_OF_CHARGE_CATEGORY_PATH,
    },
    {
      text: 'Ver',
      href: `${FREE_OF_CHARGE_CATEGORY_PATH}/${id}`,
    },
    {
      text: 'Editar',
      href: '',
    },
  ],
  freeOfChargeCategory: SalesUnit.FreeOfChargeCategory.getIn([
    'current',
    'content',
  ]),
  loading: !SalesUnit.FreeOfChargeCategory.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditFreeOfChargeCategory);
